import "./ParagraphEdit.scss";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FieldSetEdit, TextAreaEdit } from '../'
import { globalContext } from "../../../../../../contexts";

const ParagraphEdit = ({ form, section, component, fieldset, lang, handleChangeValuesSection }) => {
  const { t } = useTranslation('forms')
  const { currentUser } = useContext(globalContext)

  const handleChangeText = (value) => {
    let text = component.text??{}
    text[lang] = value
    component.text = text
    handleChangeValuesSection(section)
  }

  return (
    <div className="form-manager-paragraph-edit">
        <TextAreaEdit component={component} lang={lang} handleChangeText={handleChangeText} />
        { fieldset ? 
          <>
            <h4>
              <p>{t("forms.manager.paragraphEdit.optionalFields")}</p>
              <ul>
                <li>{t("forms.manager.paragraphEdit.optionalFields1")}</li>
                {!currentUser?.cliente?.outsourcer ?
                  <li>{t("forms.manager.paragraphEdit.optionalFields2")}</li>
                  :
                  <li>{t("forms.manager.paragraphEdit.optionalFields3")}</li>
                }
              </ul>
            </h4>
            <FieldSetEdit hasHeader={false} form={form} section={section} component={component} fieldset={fieldset} lang={lang} handleChangeValuesSection={handleChangeValuesSection} />
          </>
          :
          <h4>
            <p>{t("forms.manager.paragraphEdit.optionalFields")}</p>
            <ul>
              {!currentUser?.cliente?.outsourcer ?
                <li>{t("forms.manager.paragraphEdit.optionalFields2")}</li>
                :
                <li>{t("forms.manager.paragraphEdit.optionalFields3")}</li>
              }
            </ul>
          </h4>
        }
    </div>
  )
}

export default ParagraphEdit;